import { Fragment, useEffect } from 'react'
import { Button, Card, Col, Row } from 'reactstrap'
import BusinessForm from './components/form/businessForm'
import { UploadCloud } from 'react-feather'
import AddLogo from './components/modals/addLogo'
import { useDispatch } from 'react-redux'
import { setOpenModal } from './store'
import {
  getDepartments,
  getDocumentTypes,
  getEconomicActivities,
  getOfferTypes,
  getTaxpayerTypes,
} from '../invoice-issuance/thunks'
import { getIssuerInfo } from './thunks'
import { EmailAuthForm } from './components/form/emailAuthForm'
import { users } from '../invoice-issuance/db/users'
import { getDefaultLoginCredentials } from '../../../utility/utils'

// "Configuracion de recepcion de correo" solo aplica a TechyWe y CrediQ -
// las demas empresas (ej. Unillantas) no deben verla. CrediQ no tiene un
// companyId propio en users.js: entra por la cuenta "por defecto" (la misma
// que usa getDefaultUserCredentials/getIssuerInfo como respaldo), cuyo valor
// cambia segun el ambiente (ver getDefaultLoginCredentials).
const userBillingData = JSON.parse(localStorage.getItem('userBilligData'))
const loggedInCompanyId = users.find(
  (u) => u.companyId === userBillingData?.username
)?.companyId
const { userName: crediqCompanyId } = getDefaultLoginCredentials()
const mostrarConfigCorreo =
  loggedInCompanyId === 'techy_we' || loggedInCompanyId === crediqCompanyId

const BusinessManager = () => {
  const dispatch = useDispatch()

  const handleOpenModal = () => {
    dispatch(setOpenModal({ open: true }))
  }

  /* inicializar catalogos */
  useEffect(() => {
    dispatch(getDepartments())
    dispatch(getEconomicActivities())
    dispatch(getDocumentTypes())
    dispatch(getIssuerInfo())
    dispatch(getOfferTypes())
    dispatch(getTaxpayerTypes())
  }, [dispatch])
  return (
    <Fragment>
      <AddLogo />
      <Card>
        <BusinessForm addLogo={handleOpenModal} />
        <Row>
          <Col className="d-flex align-items-center justify-content-sm-center mx-2 my-3">
            <Button
              className="mx-2"
              style={{ size: '10px', width: '200px' }}
              color="primary"
              onClick={handleOpenModal}
            >
              <UploadCloud size={20} /> Añadir logo
            </Button>
          </Col>
        </Row>
      </Card>
      {mostrarConfigCorreo && <EmailAuthForm />}
    </Fragment>
  )
}

export default BusinessManager
